// extracted by mini-css-extract-plugin
module.exports = {"SelectCategory":"SelectCategory_SelectCategory__25Gb6","Burger":"SelectCategory_Burger__2QqeW"};